/**
 *  ApCore JS
 *  Author: Adviva
 */

export default class AdvivaCore {
    constructor(){
        //
    }

    init(){
        window.lastScrollTop = 0;

        window.isScrollingUp = false;

        window.currentScroll = false;
    }

    /**
     * Scroll to Top
     */
    setCurrentScrollTop(){
        window.currentScroll = jQuery(window).scrollTop();
    }

    /**
     * to TOP manager
     * @param el
     * @param offset
     */
    scrollToTopManager(el, offset=200){
        var element = jQuery(el);
        jQuery(window).scroll(function(){
            if (window.isScrollingUp && window.currentScroll > offset){
                // SCROLLING UP
                element.addClass('active');
            } else {
                // SCROLLING DOWN
                element.removeClass('active');
            }
        });
    }

    /**
     * Scroll To TOP
     */
    scrollToTop(){
        jQuery(document).ready(function(){
            jQuery('html, body').animate({
                scrollTop: 0,
            }, 1500);
        });
    }


    setScrollDirection(){
        let nowScrollTop = jQuery(window).scrollTop();
        if (nowScrollTop > window.lastScrollTop && nowScrollTop > 0 && nowScrollTop > 1){
            // SCROLLING DOWN
            window.isScrollingUp = false;
        } else {
            // SCROLLING UP
            window.isScrollingUp = true;
        }
        window.lastScrollTop = nowScrollTop;

        return window.isScrollingUp;
    }

    /**
     *
     * @param parentRow
     * @param columnSelector
     */
    setEqualHeight(parentRow, columnSelector) {
        let tallest = 0;
        let group = jQuery(parentRow);
        group.each(function() {
            let column = $(this).find(columnSelector);
            column.css('height', 'auto');
            tallest = 0;
            column.each(function(i,el) {
                var thisHeight = $(el).height();
                if(thisHeight > tallest) {
                    tallest = thisHeight;
                }
            });
            column.height(tallest);
        });
    }

    /*
    * Replace all SVG images with inline SVG
    */
    replaceSVGS(){
        jQuery('.svg img, img.svg').each(function() {
            var $img = jQuery(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            jQuery.get(imgURL, function (data) {
                // Get the SVG tag, ignore the rest
                var $svg = jQuery(data).find('svg');

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
                if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                    $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
                }

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');
        });
    }

    /**
     * Auto Scroll OnHash
     */
    autoscrollOnHash() {
        let pageHash = window.location.hash;
        if (pageHash) {
            let pageHasElement = jQuery(pageHash);
            if (pageHasElement.length) {
                jQuery('body').on('advivapress.window.finalize', function () {
                    jQuery('html, body').animate({
                        scrollTop: pageHasElement.offset().top - $('#site-masthead').outerHeight(),
                    }, 1400, function(){
                        window.history.pushState("", "", window.location.origin+window.location.pathname);
                    });
                });
            }
        } if(jQuery('li.gfield_error').length > 0){
            let gfErrorElement = $('li.gfield_error');
            jQuery('body').on('advivapress.window.finalize', function () {
                jQuery('html, body').animate({
                    scrollTop: gfErrorElement.offset().top - $('#header-nav').outerHeight() - 15,
                });

            });
        }
    }

    /**
     * Scroll To
     *
     * @param anchor
     * @param fixedHeader
     */
    scrollToElement(anchor,fixedHeader){
        let aEl = jQuery('#' + anchor);
        let elOffsetTop;
        if(fixedHeader){
            let headerFixedH = jQuery('#' + fixedHeader).outerHeight(true);
            elOffsetTop = (aEl.offset().top - headerFixedH);
        }else{
            elOffsetTop = aEl.offset().top;
        }
        jQuery('html, body').animate({
            scrollTop: elOffsetTop,
        }, 1500);
    }

    /**
     * Wpml lang selector manager for WPML
     */
    toggleWpmlLangSel(){
        var subMenu = jQuery('.ap_menu .wpml-ls-item .sub-menu');
        var wrap = jQuery('.ap_menu .wpml-ls-item.wpml-ls-current-language');
        wrap.children('a').click(function(evt){
            evt.preventDefault();
            subMenu.slideToggle();
        });
    }

    /**
     * manage horizontal scroll for table mobile
     */
    apTableManager(){
        jQuery('table').wrap('<div class="ap-table-wrapper"><div class="ap_container-table"></div></div>');
        jQuery('.ap-table-wrapper').each(function (index, el) {
            if ($(this).innerWidth()< el.scrollWidth) {
                el = jQuery(el);
                el.scrollLeft(0);
                el.append('<div class="darrow danimated dbounce"><i class="icon-chevron-right"></i></div>');
                jQuery(window).scroll(function () {
                    var darrow_topVal;
                    if (jQuery(window).scrollTop() > el.offset().top) {
                        darrow_topVal = jQuery(window).scrollTop() - el.offset().top + 20;
                    } else {
                        darrow_topVal = 20;
                    }
                    el.find('i').css('top', darrow_topVal + 'px');
                });
                el.scroll(function () {
                    jQuery(this).find('.darrow').hide();
                });
            }
        });
    }

    /**
     * Gravity forms manager
     *
     */
    GformManager(){
        function isValidEmail(value){
            var re = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return value.match(re);
        }

        let select_sel = '.gfield_select';
        let checkbox_sel = '.gfield_checkbox';

        // form checkbox styling
        if(jQuery(checkbox_sel).length && !(jQuery('.gform_fields .gb-checkbox-style').length > 0)){
            jQuery(checkbox_sel).find('li input').after('<span class="gb-checkbox-style"></span>');
        }

        // select style
        if(jQuery(select_sel).length>0 && !(jQuery('.gform_fields .gb-select-wrap').length > 0)){
            jQuery(select_sel).wrap('<span class="gb-select-wrap"></span>');
        }

        var fields = jQuery('.ginput_container input, .ginput_container textarea, .ginput_container select');
        fields.each(function(i,el){
            jQuery(el).focusin(function(){
                jQuery(el).parents('.ginput_container').addClass('gb-focus');
                jQuery(el).parents('.ginput_container').parent('li.gfield').addClass('gb-focus');
            });
            jQuery(el).on('keyup focusout change', function() {
                var containsRequired = jQuery(el).parents('.gfield_contains_required');
                if(containsRequired.find('.validation_message').length === 0){
                    containsRequired.append('<div class="gfield_description validation_message"></div>');
                }

                if(jQuery(el).val()){
                    jQuery(el).parents('.ginput_container').parent('li.gfield').addClass('gb-valid').removeClass('gfield_error inline_gfield_error');
                    jQuery(el).parents('.ginput_container').siblings('.validation_message').hide();
                    if(jQuery(el).parent('.ginput_container').hasClass('ginput_container_email') && !isValidEmail(jQuery(el).val()) && containsRequired.length > 0){
                        jQuery(el).parents('.ginput_container').parent('li.gfield').addClass('gb-valid').addClass('gfield_error inline_gfield_error');
                        jQuery(el).parent().siblings('.validation_message').text(window.validation_text.invalidMail).show();
                    }
                } else {
                    jQuery(el).parents('.ginput_container').parent('li.gfield').removeClass('gb-valid');
                    if(containsRequired.length > 0){
                        jQuery(el).parents('.ginput_container').parent('li.gfield').addClass('gfield_error inline_gfield_error');
                        jQuery(el).parents('.ginput_container').siblings('.validation_message').show().text(window.validation_text.empty);
                    }
                }

            });
            if (jQuery(el).val()) {
                jQuery(el).parents('.ginput_container').parent('li.gfield').addClass('gb-valid');
            } else {
                jQuery(el).parents('.ginput_container').parent('li.gfield').removeClass('gb-valid');
            }
        });
        fields.each(function(i,el){
            jQuery(el).focusout(function(){
                jQuery(el).parents('.ginput_container').removeClass('gb-focus');
                jQuery(el).parents('.ginput_container').parent('li.gfield').removeClass('gb-focus');
            });
        });
        $('.ginput_container_checkbox').parent('.gfield').find('.gfield_label').css('display' , 'none');
        $('.ginput_container_textarea').parent('.gfield').addClass('container_textarea');
        if(jQuery('.gfield_checkbox').length && !(jQuery('.gform_wrapper .gb-checkbox-style').length > 0)){
            jQuery('.gfield_checkbox li input').after('<span class="gb-checkbox-style"></span>');
        }

        $('input.datepicker').each(function(){
            $(this).attr('autocomplete','off');
        });
    }

    /**
     * Section collapse
     *
     */
    SectionCollapse() {
        var sectionControllers = $('.mobile-section-controller');
        sectionControllers.each(function (i, el) {
            el = jQuery(el);
            el.addClass('closed');
            var sectionContent = $('#' + el.attr('id').replace("-controller", ""));
            if(sectionContent.hasClass('opened')){
                sectionContent.css('height','auto');
            }else{
                sectionContent.addClass('closed');
            }
            el.click(function (e) {
                e.preventDefault();
                el = jQuery(this);
                var sectionId = el.attr('id');
                toggleMobileSection(sectionId);
            });
        });
    }

    /**
     * Add class to slick slider when it isn't a slider
     *
     */
    ApSlickManager() {
        let slickSlider = $('.slick-slider');
        slickSlider.each(function(){
            if($(this).find('.slick-arrow').length === 0){
                $(this).addClass('ap_no-slider');
            }
            else{
                $(this).removeClass('ap_no-slider');
            }
        });
    }
}

/**
 * IS IN VIEWPORT
 * @returns {boolean}
 */
$.fn.isInViewport = function () {
    let response = false;
    if(typeof $(this).offset() !== "undefined"){
        let elementTop = $(this).offset().top;
        let elementBottom = elementTop + $(this).outerHeight();
        let viewportTop = $(window).scrollTop();
        let viewportBottom = viewportTop + $(window).height();
        response = (elementBottom > viewportTop && elementTop < viewportBottom);
    }
    return response;
};


// SmartResize Method
(function($,sr){
    var debounce = function (func, threshold, execAsap) {
        var timeout;
        return function debounced () {
            var obj = this, args = arguments;
            function delayed () {
                if (!execAsap)
                    func.apply(obj, args);
                timeout = null;
            }

            if (timeout)
                clearTimeout(timeout);
            else if (execAsap)
                func.apply(obj, args);

            timeout = setTimeout(delayed, threshold || 150);
        };
    };
    jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };
})(jQuery,'smartresize');


function toggleMobileSection(sectionControllerId) {
    var sectionController = jQuery('#' + sectionControllerId);
    var sectionContent = jQuery('#' + sectionControllerId.replace("-controller", ""));
    var curH = sectionContent.height();
    if (curH === 0) {
        openMobileSection(sectionContent);
        sectionController.addClass('opened');
        sectionController.removeClass('closed');
    } else {
        closeMobileSection(sectionContent);
        sectionController.addClass('closed');
        sectionController.removeClass('opened');
    }
}

function openMobileSection(el) {
    var element = jQuery(el);
    element.addClass('opened');
    element.removeClass('closed');
    var curHeight = element.height();
    var autoHeight = element.css('height', 'auto').height();
    element.height(curHeight).animate({height: autoHeight}, 500, function () {
        element.css('height', 'auto');
    });
}

function closeMobileSection(el) {
    var element = jQuery(el);
    element.addClass('closed');
    element.removeClass('opened');
    element.animate({height: 0}, 500);
}
